<template>
  <div class="comment-form">
    <div class="comment-form__panel-header">
      <div class="comment-form__header-title">请对本次服务进行评价</div>
      <i class="iconfont icon-close comment-form__header-icon" @click="handleClose" />
    </div>
    <div class="comment-form__panel-body">
      <div class="comment-form__input">
        <el-rate :max="scoreText.max" v-model="page.form.score" show-text :texts="scoreText.arr" text-color="#ff9900" />
      </div>
      <div class="flex flex-wrap" v-if="scoreTag.length > 0">
        <el-tag
          class="comment-form__tags"
          v-for="(item, index) in scoreTag"
          :key="index"
          :type="page.form.tag !== item ? 'info' : 'primary'"
          effect="plain"
          round
          @click="page.form.tag = item"
        >
          {{ item }}
        </el-tag>
      </div>
      <div class="comment-form__input">
        <el-input
          type="textarea"
          :rows="5"
          v-model="page.form.content"
          :maxlength="200"
          show-word-limit
          :placeholder="placeholder"
        />
      </div>
      <div class="comment-form__input flex flex-item-center" v-if="showConnect">
        问题是否解决：
        <el-switch v-model="page.form.solve" :inactive-value="0" :active-value="1" />
      </div>
      <el-button class="comment-form__btn" type="primary" :loading="page.btnLoading" @click="handleSubmit">
        提交评价
      </el-button>
    </div>
  </div>
</template>

<script setup>
import { ElMessage } from 'element-plus'
import { reactive, defineProps, computed, getCurrentInstance, defineEmits } from 'vue'
const props = defineProps({
  styleConfig: { type: Object, default: () => {} },
  commentStyle: { type: Object, default: () => {} },
  orgId: { type: String },
  chatId: { type: String },
  showType: { type: String },
  commentType: { type: Number }
})
const emit = defineEmits(['close'])
const { proxy } = getCurrentInstance()
const page = reactive({
  form: {},
  btnLoading: false
})
// 是否显示问题已解决
const showConnect = computed(() => {
  if (props.showType === 1 && props.styleConfig.isCollect) return true
  if (props.showType === 2 && props.commentStyle.isCollect) return true
  return false
})
const placeholder = computed(() => {
  if (props.showType === 2) return props.commentStyle?.remarkText || ''
  return '请输入评价内容'
})
// 评分
const scoreText = computed(() => {
  let defaultObj = {
    max: 5,
    arr: ['非常不满意', '不满意', '满意', '比较满意', '非常满意']
  }
  let key = props.showType === 2 ? 'commentStyle' : 'styleConfig'
  let commentData = props[key]?.commentData,
    commentStyle = props[key]?.commentStyle
  if (commentStyle !== null && commentData && Object.keys(commentData).length > 0) {
    let label = commentData[commentStyle].label
    let data = {
      max: label.length,
      arr: [...label]?.reverse()
    }
    return data
  }
  return defaultObj
})
// 评分标签
const scoreTag = computed(() => {
  if (!page.form.score) return []
  let key = props.showType === 2 ? 'commentStyle' : 'styleConfig'
  let tags = props[key]?.commentData[props[key]?.commentStyle]?.tags || []
  let arr = [],
    max = Object.keys(tags).length
  if (page.form.score === max) {
    arr = tags[0]
  } else if (page.form.score < max) {
    arr = tags[max - page.form.score]
  }
  return arr
})
const handleClose = () => {
  page.form = {}
  emit('close')
}
const handleSubmit = () => {
  if (!page.form.score) return ElMessage.error('请选择评价满意度！')
  let key = props.showType === 2 ? 'commentStyle' : 'styleConfig'
  let must = props[key]?.commentData[props[key]?.commentStyle]?.must || {}
  let max = Object.keys(must).length
  let data = must[Math.abs(page.form.score - max)]
  if (data?.requireTag && !page.form.tag) {
    return ElMessage.error('请选择评价标签！')
  }
  if (data?.requireRemark && (!page.form.content || !/\S/.test(page.form.content))) {
    return ElMessage.error('请输入评价内容！')
  }
  if (props.showType === 2) {
    handleServiceComment()
  } else if (props.showType === 1) {
    handleRobotComment()
  }
}
// type 评价类型:
// 0 客户主动评价
// 1手动邀请评价
// 2座席端结束自动邀评
// 3客户端结束自动邀评
// 4系统结束自动邀评

// 在线客服评价
const handleServiceComment = async () => {
  if(!proxy.$ws.sessionInfo.sessionId){
    return false
  }
  let params = {
    content: page.form.content,
    custId: proxy.$ws.userInfo.userId,
    level: props.commentStyle.commentStyle,
    orgId: props.orgId,
    score: page.form.score,
    sessionId: proxy.$ws.sessionInfo.sessionId,
    solve: page.form.solve ? 1 : 0,
    tags: [page.form.tag],
    type: props.commentType
  }
  page.btnLoading = true
  let res = await proxy.$http.post('/app/custClient/saveComment', params)
  if (res.code === 0) {
    handleClose()
  } else {
    ElMessage.error(res.msg)
  }
  page.btnLoading = false
}
// 机器人评价
const handleRobotComment = async () => {
  let id = localStorage.getItem('senderId')
  let params = {
    content: page.form.content,
    level: `${props.styleConfig.commentStyle}-${page.form.score}`,
    orgId: props.orgId,
    solveType: page.form.solve,
    subject: props.chatId,
    tags: [page.form.tag],
    sessionId: props.chatId,
    userId: id,
    score: page.form.score,
  }
  page.btnLoading = true
  let res = await proxy.$http.post('/textrobot/app/chat/comment', params)
  if (res.code === 0) {
    ElMessage.success(props.styleConfig?.thankWords || '感谢您的反馈！')
    handleClose()
  } else {
    ElMessage.error(res.msg)
  }
  page.btnLoading = false
}
</script>

<style lang="less" scoped>
.comment-form {
  // width: 200px;
  &__panel-header {
    padding: 0 10px;
    line-height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
  }
  &__header-title {
    color: #666666;
  }
  &__header-icon {
    color: #999999;
    cursor: pointer;
  }
  &__panel-body {
    padding: 25px 10px;
  }
  &__input {
    display: flex;
    font-size: 14px;
    color: #666666;
    margin-bottom: 10px;
    :deep(.el-textarea__inner) {
      background: #f8f8f8;
      box-shadow: unset;
    }
  }
  &__btn {
    width: 100%;
    border: none;
    background: #3571f0;
  }
  &__tags {
    margin: 0 12px 8px 0;
    cursor: pointer;
  }
}
</style>
